module.exports = __webpack_public_path__ + "img/bangladesh.0c17cd9d.svg";